import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@alfresco/adf-core';
import { ContentModule } from '@alfresco/adf-content-services';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PageLayoutModule, SharedModule } from '@alfresco/aca-shared';

import { WkSemanticSearchResultsComponent } from './wk-semantic-search-results.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ContentModule,
    SharedModule,
    PageLayoutModule,
    MatProgressBarModule,
    MatIconModule,
    MatButtonModule,
  ],
  declarations: [WkSemanticSearchResultsComponent],
  exports: [WkSemanticSearchResultsComponent],
})
export class WkSemanticSearchResultsModule {}
